require('./dist/angular-validation-match');
module.exports = 'validation.match';



//////////////////
// WEBPACK FOOTER
// ./~/angular-validation-match/index.js
// module id = 27
// module chunks = 0